import React from 'react';
import PropTypes from 'prop-types';

const ICON_SIZE = {
  small: 12,
  medium: 14,
  large: 16,
};

export function ExpiredWarrantyWarningIcon({ size = 'medium' }) {
  return <span className={`icon-notification2 text-orange-30 size-${ICON_SIZE[size]}`} aria-hidden />;
}

ExpiredWarrantyWarningIcon.propTypes = {
  size: PropTypes.oneOf(Object.keys(ICON_SIZE)),
};
